export default __webpack_public_path__ + "static/media/evenShotBg.ff7737d3.png";